<!-- 选择收费类型 -->
<template>
  <el-form-item :label="label">
    <yx-orderflag-selector
      @select="select"
      ref="child"
      @clear="reset"
      :queryParams="params"
      :immediate="config.immediate"
      :placeholder="config.placeholder"
      width="222px"
      v-bind="config"
    />
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-收费类型选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          clearable: true,
          immediate: true,
          placeholder: '',
        };
      },
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '收费类型：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function reset() {
      child.value.clearField();
      // eslint-disable-next-line no-use-before-define
      orderflag.value = {};
    }
    const orderflag = useQuery('orderflag', props.value, reset);

    function select(obj) {
      orderflag.value = obj;
    }

    return {
      select,
      child,
      reset,
    };
  },
};
</script>
